import { useEffect, useState } from "react";
import './studio.css';

const postSurveyQuestions = [
    { question: 'Have you worked with the Enneagram before and do you know your type?', field: 'QuestionOne' },
    { question: 'What is your Enneagram Type?', field: 'QuestionTwo' },
    { question: 'What is your dominant instinct?', field: 'QuestionThree' },
    { question: 'How were you typed?', field: 'QuestionFour' },
    { question: 'Please indicate what test you have done before', field: 'QuestionFive' },
];
const sectionNames = 'Within Centre,Trifix,Instincts'.split(',');
const maturityStages = ',Self-protecting,Conforming,Specialising,Performing,Internalising,Strategising,Transforming,Being,'.split(',');
const maturityCodes = ',SE,CO,SP,PE,IN,ST,TR,BE'.split(',');
const chartFontName = 'Quicksand';

//const host = `https://aim.aephoria.co.za/`;
//const host = 'https://aim-stage-dot-aephoria-173418.ew.r.appspot.com/';
let host = window.location.origin + '/';
if (host.includes('3100'))
    host = host.replace('3100', '3000');

const StudioContent = (props) => {

    const gEnneaNames = {};

    function rgbToHash(c) {
        let s = '#';
        for (let i in c) {
            let v = c[i];
            v = v.toString(16);
            v = v.toUpperCase();
            while (v.length < 2) v = '0' + v;
            s = s + v;
        }
        return (s);
    }

    function getMaturityColor(imfNewCode) {
        var colors = {
            'SE': [237, 154, 77],
            'CO': [245, 190, 139],
            'SP': [236, 193, 13],
            'PE': [244, 214, 124],
            'IN': [246, 171, 178],
            'ST': [241, 123, 143],
            'TR': [206, 171, 208],
            'BE': [178, 116, 177]
        };
        return (rgbToHash(colors[imfNewCode]));
    }

    // colors and layout below are ported 1:1 from public/newreports/imfnew/extras/chart-imfCoG-fan.js,
    // which draws the 'cog_canvas' fan chart used in the imfCS.htm coaching-suggestions PDF report.
    function getFanMaturityColor(imfNewCode) {
        var colors = {
            'SE': [238, 117, 41],
            'CO': [245, 167, 116],
            'SP': [235, 172, 19],
            'PE': [244, 201, 119],
            'IN': [229, 143, 163],
            'ST': [217, 81, 124],
            'TR': [183, 147, 179],
            'BE': [144, 85, 134]
        };
        return (rgbToHash(colors[imfNewCode]));
    }

    function getPerfectPercentages(scores) {
        const sumScores = scores.reduce((sum, score) => sum + score, 0);
        if (sumScores === 0) return scores.map(() => 0);
        let mapped = scores.map((score, originalIndex) => {
            const exactPercent = (score / sumScores) * 100;
            return {
                originalIndex: originalIndex,
                integerPart: Math.floor(exactPercent),
                remainder: exactPercent - Math.floor(exactPercent)
            };
        });
        let currentSum = mapped.reduce((sum, item) => sum + item.integerPart, 0);
        let shortfall = 100 - currentSum;
        mapped.sort((a, b) => b.remainder - a.remainder);
        for (let i = 0; i < shortfall; i++) {
            mapped[i].integerPart += 1;
        }
        mapped.sort((a, b) => a.originalIndex - b.originalIndex);
        return mapped.map(item => item.integerPart);
    }

    function getEnneaColor(eNumber) {
        var colors = { 
            8: [201,64,70],
            9: [209,103,96],
            1: [228,171,160],
            2: [67,171,113],
            3: [147,197,162],
            4: [182,214,189],
            5: [60,98,160],
            6: [138,150,193],
            7: [202,206,226]
        };
        return(rgbToHash(colors[eNumber]));
    }

    function drawTripleBar(ystart, c, title, colors, dots, captions, xstart, scores, xlabeloffset, xbaroffset, barlength) {

        function roundedRect(ctx, x, y, w, h, r) {
            if (w < r) {
                w = r;
                r = r / 2;
            }
            ctx.beginPath();
            ctx.moveTo(x + r, y);
            ctx.arcTo(x + w, y, x + w, y + h, r);
            ctx.lineTo(x + w, y + h - r);
            ctx.arcTo(x + w, y + h, x, y + h, r);
            ctx.lineTo(x + w - r, y + h);
            ctx.arcTo(x, y + h, x, y + r, r);
            ctx.lineTo(x, y + r);
            ctx.arcTo(x, y, x + w - r, y, r);
            ctx.closePath();
            ctx.fill();
            ctx.stroke();
        }
        if (!c)
            return;
        if (!barlength)
            barlength = 450;
        let ctx = c.getContext("2d");
        // draw heading
        ctx.textAlign = "right";
        ctx.textBaseline = "top";
        ctx.font = `bold 58px ${chartFontName}`;
        //c.style.letterSpacing = "20px";
        let y = ystart;
        ctx.fillStyle = '#000000';
        if (title) {
            ctx.fillText(title, xstart + xbaroffset - 18, y);
            y += 105;
        }
        let textcolor = '#000000';
        for (let i in captions) {
            // draw bars
            let barcolor = colors[i];
            let score = scores[i];
            let len = barlength * score;
            let barthickness = 70;
            ctx.strokeStyle = barcolor;
            ctx.fillStyle = barcolor;
            roundedRect(ctx, xstart + xbaroffset, y - barthickness / 2, len, barthickness, 20);
            // draw labels
            ctx.font = `bold 44px ${chartFontName}`;
            ctx.fillStyle = textcolor;
            ctx.strokeStyle = textcolor;
            ctx.textAlign = "right";
            ctx.textBaseline = 'middle';
            ctx.fillText(captions[i], xstart + xbaroffset - 18, y);
            let d = dots[i];
            ctx.fillStyle = '#ffffff';
            if (d) {
                let x = xstart + xbaroffset + barthickness * 0.5;
                for (let c = 0; c < d.length; c++) {
                    let dr = barthickness * 0.3;
                    if (d[c] === 'o')
                        dr = barthickness * 0.17;
                    ctx.beginPath();
                    if (c > 0) x += dr;
                    ctx.arc(x, y, dr, 0, 2 * Math.PI);
                    ctx.fill();
                    x += dr + 10;
                }
            }
            y += 90;
        }
    }

    function drawInstincts(c, justText,notEnglish,language,names) {
        let scores = props.results.scores;
        if (!scores)
            return;
        function getInstinctScores(nonormal) {
            let s = [];
            let instincts = ['SP', 'SO', 'SX'];
            for (var i in instincts) {
                // old way: if <0.2, set to 0.2, and divide by 12.5
                //s.push(normalize('s3', scores.main, instincts[i], scores.s3[instincts[i]][4]));
                // or new way
                // scores can range from -4 to 12.5
                if (nonormal)
                    s.push(scores.s3[instincts[i]][4])
                else
                    s.push((4 + scores.s3[instincts[i]][4]) / 16.5)
            }
            return (s)//[0,1,0.5]);
        }
        if (justText) {
            /*
            let x = getInstinctScores();
            let y = [
                {name:'Self-Preservation',score:x[0]},
                {name:'Social',score:x[1]},
                {name:'One-on-One',score:x[2]},
            ];
            y.sort((a,b)=>b.score-a.score);
            let s = <div className="a_paragraph">The dominant instinct is {y[0].name}, and the neglected instinct is {y[2].name}</div>
            return(s);
            */
            let x = getInstinctScores(true);
            let y = [
                { name: 'Self-Preservation', score: x[0] },
                { name: 'Social', score: x[1] },
                { name: 'One-on-One', score: x[2] },
            ];
            let s = <div className="a_paragraph">
                <div>{y[0].name} scores {y[0].score}</div>
                <div>{y[1].name} scores {y[1].score}</div>
                <div>{y[2].name} scores {y[2].score}</div>
            </div>
            return (s);
        }
        if (!c)
            return;
        let ctx = c.getContext("2d");
        idcanvas(ctx, c);
        drawTripleBar(60, c, null, ['#aa65a8', '#aa65a8', '#aa65a8'], ['', '', ''],
            names,
            236, getInstinctScores(), 0, 350, 450); // last number should be 650 for left-align
    }

    function drawTripleBars(c) {
        let scores = props.results.scores;
        if (!c)
            return;
        let ctx = c.getContext("2d");
        idcanvas(ctx, c);
        function getTripleScores(triples) {
            let s = [];
            let dots = [];
            let ds = [];
            for (var triple of triples) {
                let t = 0;
                let d = '';
                for (var e of triple) {
                    if (e === scores.main)
                        d = 'O' + d;
                    else
                        if (scores.tritype.includes(e.toString()))
                            d += 'o';
                    t += scores.s1[e][5];
                }
                dots.push(d)
                ds.push(t + ' ' + d);
                // scores can range from -15 to 48
                s.push((t + 15) / 63);
            }
            return ({
                scores: s,//[0,1,0.5],
                dots: dots,
                both: ds
            });
        }
        /*
        let xbaroffset = 250;
        let ts = getTripleScores([[9,2,7],[1,3,5],[8,6,4]]);
        drawTripleBar(100, c, "HARMONICS", ['#6c9ecdFF','#6c9ecdAF','#6c9ecd5F'], ts.dots,
            ['Positive Outlook', 'Competency', 'Emotional\nRealness'], 
            //ts.both,
            100, ts.scores,400,xbaroffset);
        ts = getTripleScores([[8,3,7],[1,2,6],[9,4,5]]); 
        drawTripleBar(100, c, "HORNEVIANS", ['#ab66a8FF','#ab66a8AF','#ab66a85F'], ts.dots,
            ['Assertive/\nMove Against', 'Compliant/\nMove With', 'Withdrawn/\nMove Away'], 
            //ts.both,
            859, ts.scores,400,xbaroffset);
        ts = getTripleScores([[8,2,5],[1,4,7],[9,3,6]]);
        drawTripleBar(100, c, "OBJECT RELATIONS", ['#99ca3fFF','#99ca3fAF','#99ca3f5F'], ts.dots,
            ['Rejection', 'Frustration', 'Attachment'], 
            //ts.both,
            1618, ts.scores,400,xbaroffset);
        */
        let xbaroffset = 500;
        let ystart = 60;
        let yinc = 450;
        let ts = getTripleScores([[9, 2, 7], [1, 3, 5], [8, 6, 4]]);
        drawTripleBar(ystart, c, "HARMONICS", ['#6c9ecdFF', '#6c9ecdAF', '#6c9ecd5F'], ts.dots,
            ['Positive Outlook', 'Competency', 'Emotional\nRealness'],
            //ts.both,
            100, ts.scores, 400, xbaroffset);
        ystart += yinc;
        ts = getTripleScores([[8, 3, 7], [1, 2, 6], [9, 4, 5]]);
        drawTripleBar(ystart, c, "HORNEVIANS", ['#ab66a8FF', '#ab66a8AF', '#ab66a85F'], ts.dots,
            ['Assertive /\nMove Against', 'Compliant /\nMove With', 'Withdrawn /\nMove Away'],
            //ts.both,
            100, ts.scores, 400, xbaroffset);
        ystart += yinc;
        ts = getTripleScores([[8, 2, 5], [1, 4, 7], [9, 3, 6]]);
        drawTripleBar(ystart, c, "OBJECT RELATIONS", ['#99ca3fFF', '#99ca3fAF', '#99ca3f5F'], ts.dots,
            ['Rejection', 'Frustration', 'Attachment'],
            //ts.both,
            100, ts.scores, 400, xbaroffset);
    }

    function drawEnneaWingsLines(c) {
        if (!c)
            return;
        let scores = props.results.scores;
        function toRad(a) {
            return ((a / 360) * 2 * Math.PI);
        }
        function circle(x, y, r, linewidth, style, skipstroke, a1, a2, counterclockwise) {
            //ctx.moveTo(x +r*Math.cos(0),y);
            if (!a1) {
                a1 = 0;
                a2 = 2 * Math.PI;
                counterclockwise = false;
            }
            ctx.beginPath();
            ctx.arc(x, y, r, a1, a2, counterclockwise);
            //ctx.closePath();
            ctx.lineWidth = linewidth;
            ctx.strokeStyle = style;
            if (!skipstroke)
                ctx.stroke();
        }
        function getEnneaAngle(e) {
            let step = 360 / 9;
            return (e * step);
        }
        function coord(r, a) {
            a -= 90;
            return ({
                x: xc + r * Math.cos(toRad(a)),
                y: yc + r * Math.sin(toRad(a))
            });
        }
        let ctx = c.getContext("2d");
        idcanvas(ctx, c);
        let w = 4800;
        let showGrid = true;
        let xc = 1240;
        let yc = 1240;
        let r = 900;
        // draw outside boundary of nine ennea color arcs
        for (let e = 1; e <= 9; e++) {
            let a1 = getEnneaAngle(e) - 90 + 360 / 9 / 2 - 0.5;
            let a2 = getEnneaAngle(e) - 90 - 360 / 9 / 2 + 0.5;
            circle(xc, yc, r + 245, 86, getEnneaColor(e), false, toRad(a1), toRad(a2), true);
        }
        let ri = 3 * (w / 2.0) / 9.0;
        let rs = w / 2 / 17;
        let stationfontsize = w / 2 / 15;
        let linewidth = w / 2 / 44;
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.font = "normal normal " + stationfontsize + `px ${chartFontName}`;
        for (let pass = 1; pass <= 2; pass++) {
            if (pass === 1) {
                // enneagram foundation
                ctx.beginPath();
                var p1 = coord(r, getEnneaAngle(1));
                var p2 = coord(r, getEnneaAngle(2));
                var p3 = coord(r, getEnneaAngle(3));
                var p4 = coord(r, getEnneaAngle(4));
                var p5 = coord(r, getEnneaAngle(5));
                var p6 = coord(r, getEnneaAngle(6));
                var p7 = coord(r, getEnneaAngle(7));
                var p8 = coord(r, getEnneaAngle(8));
                var p9 = coord(r, getEnneaAngle(9));
                ctx.moveTo(p1.x, p1.y);
                ctx.lineTo(p7.x, p7.y);
                ctx.lineTo(p5.x, p5.y);
                ctx.lineTo(p8.x, p8.y);
                ctx.lineTo(p2.x, p2.y);
                ctx.lineTo(p4.x, p4.y);
                ctx.lineTo(p1.x, p1.y);
                ctx.moveTo(p9.x, p9.y);
                ctx.lineTo(p6.x, p6.y);
                ctx.lineTo(p3.x, p3.y);
                ctx.lineTo(p9.x, p9.y);
                ctx.closePath();
                ctx.lineWidth = linewidth;
                ctx.strokeStyle = '#e0e0e0';
                ctx.stroke();
            }
            for (let e = 1; e <= 9; e++) {
                let a = getEnneaAngle(e);
                if (pass === 1) {
                    // metric circle
                    circle(xc, yc, ri + (r - ri), 3, '#a0a0a0', !showGrid);
                }
                if (pass === 1) {
                    // main lines
                    for (let l in scores.lines) {
                        let line = scores.lines[l];
                        let pmain = coord(r, getEnneaAngle(scores.main));
                        let pline = coord(r, getEnneaAngle(line));
                        ctx.beginPath();
                        ctx.moveTo(pmain.x, pmain.y);
                        ctx.lineTo(pline.x, pline.y);
                        ctx.closePath();
                        ctx.lineWidth = linewidth;
                        let grd = ctx.createLinearGradient(pmain.x, pmain.y, pline.x, pline.y);
                        grd.addColorStop(0, getEnneaColor(scores.main));
                        grd.addColorStop(1, getEnneaColor(line));
                        ctx.strokeStyle = grd;
                        ctx.stroke();
                    }
                    // main wings
                    let anticlock = false;
                    for (let w in scores.wings) {
                        let wing = scores.wings[w];
                        let pmain = coord(r, getEnneaAngle(scores.main));
                        let pwing = coord(r, getEnneaAngle(wing));
                        ctx.beginPath();
                        ctx.arc(xc, yc, r, toRad(getEnneaAngle(scores.main) - 90), toRad(getEnneaAngle(wing) - 90), anticlock);
                        //ctx.closePath();
                        ctx.lineWidth = linewidth;
                        let grd = ctx.createLinearGradient(pmain.x, pmain.y, pwing.x, pwing.y);
                        grd.addColorStop(0, getEnneaColor(scores.main));
                        grd.addColorStop(1, getEnneaColor(wing));
                        ctx.strokeStyle = grd;
                        ctx.stroke();
                        anticlock = true;
                    }
                }
                // draw ennea stations
                let p = coord(r, a);
                // the circle
                circle(p.x, p.y, rs, 3, '#000000');
                ctx.fillStyle = scores.main === e ? '#a0a0a0' : '#ffffff';
                ctx.fill();
                // the number
                ctx.fillStyle = scores.main === e ? '#ffffff' : '#000000'
                let etext = e.toString();
                //if (e==scores.releaseStation)
                //    etext = etext+'r';//'relax';
                //if (e==scores.stretchStation)
                //    etext = etext+'s';//'stress';
                ctx.font = `800 132px ${chartFontName}`;
                ctx.fillText(etext, p.x, p.y);
            }
        }
    }

    function drawEnneaBar(c, justText) {
        let scores = props.results.scores;
        if (!scores)
            return;
        let info = props.results.enneainfo;
        function roundedRightRect(ctx, x, y, w, h, r) {
            if (w < r) {
                w = r;
                r = r / 2;
            }
            ctx.beginPath();
            ctx.moveTo(x + r, y);
            ctx.arcTo(x + w, y, x + w, y + h, r);
            ctx.lineTo(x + w, y + h - r);
            ctx.arcTo(x + w, y + h, x, y + h, r);
            ctx.lineTo(x, y + h);
            ctx.lineTo(x, y);
            ctx.closePath();
            ctx.fill();
            ctx.stroke();
        }
        function normalizeX(section, main, e, score, scores) {
            if (!score)
                return (false);
            if ((main === e) && (section === 's1'))
                return (1.0);
            if (score < scores[section].min)
                score = scores[section].min;
            return (score / scores[section].max);
        }
        function normalizeZ(section, main, e, score, scores) {
            if (!score)
                return (false);
            if ((main === e) && (section === 's1'))
                return (scores[section].max);
            return (score);
        }
        function massageData(scores, info) {
            var graphdata = {};
            var max = -100000;
            for (var ei = 0; ei <= 8; ei++) {
                var e = [8, 9, 1, 2, 3, 4, 5, 6, 7][ei];
                var score = normalizeX('s1', scores.main, e, scores.s1[e][5], scores);
                if (score <= 0)
                    score = 0.01;
                if (score > max) max = score;
                graphdata[e] = {
                    label: info.data.ennea[e - 1].split('-')[1].trim().split('The ')[1].trim(),
                    value: score,
                    valueUnnorm: normalizeZ('s1', scores.main, e, scores.s1[e][5], scores)
                }
            }
            graphdata.max = max;
            return (graphdata);
        }
        let graphdata = massageData(scores, info);
        let enneaSequence = [8, 9, 1, 0, 2, 3, 4, 0, 5, 6, 7];
        if (justText) {
            let a = [];
            for (let i = 0; i < 11; i++) {
                let eNumber = enneaSequence[i];
                if (eNumber === 0) {
                    continue;
                }
                a.push({ number: eNumber, name: gEnneaNames[eNumber], score: graphdata[eNumber].valueUnnorm })
            }
            let s = <div className="a_paragraph">
                {a.map(k => <div>Style {k.number} {k.name} scores {k.score}</div>)}
            </div>
            return (s);
        }
        let ctx = c.getContext("2d");
        idcanvas(ctx, c);
        // draw label/bar dividing vertical line
        let xline = 780;
        let y1 = 22;
        let y2 = 1528;
        ctx.lineWidth = 3; ctx.strokeStyle = '#505050'; ctx.setLineDash([]);
        ctx.beginPath(); ctx.moveTo(xline, y1); ctx.lineTo(xline, y2); ctx.closePath(); ctx.stroke();
        let xbarbase = xline + 14;
        let ystep = ((y2 - y1) / 11) + 2;
        let fw = 2282 - xbarbase;
        let ys = y1 + ystep * 0.7;
        for (let i = 0; i < 11; i++) {
            let eNumber = enneaSequence[i];
            if (eNumber === 0) {
                ys += ystep / 1.3;
                continue;
            }
            if (graphdata[eNumber].value > 0) {
                let barlength = fw * graphdata[eNumber].value / graphdata.max;
                let barthickness = 117;
                let cornerradius = 20;
                ctx.lineWidth = 1; ctx.strokeStyle = getEnneaColor(eNumber); ctx.fillStyle = ctx.strokeStyle; ctx.setLineDash([]);
                roundedRightRect(ctx, xbarbase, ys - barthickness / 2 - 7, barlength, barthickness, cornerradius);
                ctx.textAlign = "right";
                ctx.textBaseline = "middle";
                ctx.font = `600 50px '${chartFontName}'`;
                ctx.fillStyle = '#000000';
                ctx.fillText(gEnneaNames[eNumber], xbarbase - 40, ys);
                let tw = ctx.measureText(gEnneaNames[eNumber]).width;
                ctx.fillStyle = getEnneaColor(eNumber);
                ctx.fillText(eNumber, xbarbase - 40 - tw - ctx.measureText(' ').width, ys)
            }
            ys += ystep;
        }
    }

    function drawEnneaRose(c, drawInstincts, xc0, yc0) {
        if (!props.results)
            return;
        let scores = props.results.scores;
        function normalize(section, main, e, score) {
            if (!score)
                return (false);
            if ((main === e) && (section === 's1'))
                return (1.0);
            if (score < scores[section].min)
                score = scores[section].min;
            return (score / scores[section].max);
        }
        function roundedRect(ctx, x, y, w, h, r) {
            if (w < r) {
                w = r;
                r = r / 2;
            }
            ctx.beginPath();
            ctx.moveTo(x + r, y);
            ctx.arcTo(x + w, y, x + w, y + h, r);
            ctx.lineTo(x + w, y + h - r);
            ctx.arcTo(x + w, y + h, x, y + h, r);
            ctx.lineTo(x + w - r, y + h);
            ctx.arcTo(x, y + h, x, y + r, r);
            ctx.lineTo(x, y + r);
            ctx.arcTo(x, y, x + w - r, y, r);
            ctx.closePath();
            ctx.fill();
            ctx.stroke();
        }
        function toRad(a) {
            return ((a / 360) * 2 * Math.PI);
        }
        function circle(x, y, r, linewidth, style, skipstroke, a1, a2, counterclockwise) {
            //ctx.moveTo(x +r*Math.cos(0),y);
            if (!a1) {
                a1 = 0;
                a2 = 2 * Math.PI;
                counterclockwise = false;
            }
            ctx.beginPath();
            ctx.arc(x, y, r, a1, a2, counterclockwise);
            //ctx.closePath();
            ctx.lineWidth = linewidth;
            ctx.strokeStyle = style;
            if (!skipstroke)
                ctx.stroke();
        }
        function getEnneaAngle(e) {
            var step = 360 / 9;
            return (e * step);
        }
        function coord(r, a) {
            a -= 90;
            return ({
                x: xc + r * Math.cos(toRad(a)),
                y: yc + r * Math.sin(toRad(a))
            });
        }
        function basePoints(e, r) {
            var step = 360 / 9;
            var a = getEnneaAngle(e);
            a -= step / 2;
            return ({
                p1: coord(r, a),
                p2: coord(r, a + step)
            });
        }
        function basePointsNarrow(e, r) {
            var step = 360 / 9;
            var a = getEnneaAngle(e);
            return ({
                p1: coord(r, a - step / 5),
                p2: coord(r, a + step / 5)
            });
        }
        if (!c)
            return;
        const ctx = c.getContext("2d");
        idcanvas(ctx, c);
        ctx.fillStyle = "#000000";
        let w = 1900;
        let showGrid = true;
        let xc = 1240;
        let yc = 1240;
        let r = 1100;
        // draw outside boundary of nine ennea color arcs
        for (let e = 1; e <= 9; e++) {
            let a1 = getEnneaAngle(e) - 90 + 360 / 9 / 2 - 0.5;
            let a2 = getEnneaAngle(e) - 90 - 360 / 9 / 2 + 0.5;
            circle(xc, yc, r + 95, 33, getEnneaColor(e), false, toRad(a1), toRad(a2), true);
        }
        let ri = 3 * (w / 2.0) / 9.0;
        let rs = w / 2 / 17;
        let mainfontsize = w / 2 / 8;
        let stationfontsize = w / 2 / 15;
        let linewidth = w / 2 / 44;
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        // main
        ctx.font = "normal normal " + mainfontsize + `px ${chartFontName}`;
        ctx.fillText(scores.main.toString(), xc, yc);
        // tritype second
        ctx.font = "normal normal " + stationfontsize + `px ${chartFontName}`;
        let p = coord(rs, getEnneaAngle(5));
        // tritype third
        ctx.fillText(scores.tritype[1].toString(), p.x - rs / 2, p.y);
        p = coord(rs, getEnneaAngle(4));
        ctx.fillText(scores.tritype[2].toString(), p.x + rs / 2, p.y);
        ctx.font = "normal normal " + stationfontsize + `px ${chartFontName}`;
        for (let pass = 1; pass <= 2; pass++) {
            if (pass === 1) {
                // enneagram foundation
                ctx.beginPath();
                let p1 = coord(r, getEnneaAngle(1));
                let p2 = coord(r, getEnneaAngle(2));
                let p3 = coord(r, getEnneaAngle(3));
                let p4 = coord(r, getEnneaAngle(4));
                let p5 = coord(r, getEnneaAngle(5));
                let p6 = coord(r, getEnneaAngle(6));
                let p7 = coord(r, getEnneaAngle(7));
                let p8 = coord(r, getEnneaAngle(8));
                let p9 = coord(r, getEnneaAngle(9));
                ctx.moveTo(p1.x, p1.y);
                ctx.lineTo(p7.x, p7.y);
                ctx.lineTo(p5.x, p5.y);
                ctx.lineTo(p8.x, p8.y);
                ctx.lineTo(p2.x, p2.y);
                ctx.lineTo(p4.x, p4.y);
                ctx.lineTo(p1.x, p1.y);
                ctx.moveTo(p9.x, p9.y);
                ctx.lineTo(p6.x, p6.y);
                ctx.lineTo(p3.x, p3.y);
                ctx.lineTo(p9.x, p9.y);
                ctx.closePath();
                ctx.lineWidth = linewidth;
                ctx.strokeStyle = '#e0e0e0';
                ctx.stroke();
            }
            for (var e = 1; e <= 9; e++) {
                let a = getEnneaAngle(e);
                // draw section 1 outward petals
                let score = normalize('s1', scores.main, e, scores.s1[e][5]);
                let bps = basePoints(e, ri);
                let p = coord(ri + (r - ri) * score, a);
                ctx.beginPath();
                ctx.moveTo(bps.p1.x, bps.p1.y);
                ctx.lineTo(p.x, p.y);
                ctx.lineTo(bps.p2.x, bps.p2.y)
                ctx.lineTo(bps.p1.x, bps.p1.y);
                ctx.closePath();
                ctx.lineWidth = 1;
                ctx.strokeStyle = '#000000';
                ctx.stroke();
                ctx.fillStyle = getEnneaColor(e);
                ctx.fill();
                if (pass === 1) {
                    // metric circle
                    circle(xc, yc, ri + (r - ri) * score, 1, '#a0a0a0', !showGrid);
                }
                // draw section 2 inward petals
                if (scores.s2[e]) {
                    let score = normalize('s2', scores.main, e, scores.s2[e][5]);
                    if (pass === 2) {
                        let bps = basePointsNarrow(e, ri - linewidth);
                        let p2 = coord(ri - ri * score - linewidth, a);
                        ctx.beginPath();
                        ctx.moveTo(bps.p1.x, bps.p1.y);
                        ctx.lineTo(p2.x, p2.y);
                        ctx.lineTo(bps.p2.x, bps.p2.y)
                        ctx.lineTo(bps.p1.x, bps.p1.y);
                        ctx.closePath();
                        ctx.lineWidth = 1;
                        ctx.strokeStyle = '#000000';
                        ctx.stroke();
                        ctx.fillStyle = getEnneaColor(e);
                        ctx.fill();
                    }

                    if (pass === 1) {
                        // metric circle
                        circle(xc, yc, ri - ri * score, 1, '#a0a0a0', !showGrid);
                    }
                }
                if (pass === 1) {
                    // main lines
                    for (let l in scores.lines) {
                        let line = scores.lines[l];
                        let pmain = coord(r, getEnneaAngle(scores.main));
                        let pline = coord(r, getEnneaAngle(line));
                        ctx.beginPath();
                        ctx.moveTo(pmain.x, pmain.y);
                        ctx.lineTo(pline.x, pline.y);
                        ctx.closePath();
                        ctx.lineWidth = linewidth;
                        let grd = ctx.createLinearGradient(pmain.x, pmain.y, pline.x, pline.y);
                        grd.addColorStop(0, getEnneaColor(scores.main));
                        grd.addColorStop(1, getEnneaColor(line));
                        ctx.strokeStyle = grd;
                        ctx.stroke();
                    }
                    // main wings
                    let anticlock = false;
                    for (let w in scores.wings) {
                        let wing = scores.wings[w];
                        let pmain = coord(r, getEnneaAngle(scores.main));
                        let pwing = coord(r, getEnneaAngle(wing));
                        ctx.beginPath();
                        ctx.arc(xc, yc, r, toRad(getEnneaAngle(scores.main) - 90), toRad(getEnneaAngle(wing) - 90), anticlock);
                        //ctx.closePath();
                        ctx.lineWidth = linewidth;
                        let grd = ctx.createLinearGradient(pmain.x, pmain.y, pwing.x, pwing.y);
                        grd.addColorStop(0, getEnneaColor(scores.main));
                        grd.addColorStop(1, getEnneaColor(wing));
                        ctx.strokeStyle = grd;
                        ctx.stroke();
                        anticlock = true;
                    }
                }
                // draw ennea stations
                p = coord(r, a);
                // the circle
                circle(p.x, p.y, rs, 1, '#000000');
                ctx.fillStyle = scores.tritype.indexOf(e.toString()) > -1 ? getEnneaColor(e) : '#ffffff';
                ctx.fill();
                // the number
                ctx.fillStyle = '#000000';
                let etext = e.toString();
                if (e === scores.releaseStation)
                    etext = etext + 'r';//'relax';
                if (e === scores.stretchStation)
                    etext = etext + 's';//'stress';
                ctx.font = `600 52px ${chartFontName}`;
                ctx.fillText(etext, p.x, p.y);
            }
            // tritype divison
            if (pass === 1) {
                for (let e = 1; e <= 9; e++) {
                    let bps = basePoints(e, ri);
                    ctx.beginPath();
                    ctx.moveTo(bps.p1.x, bps.p1.y);
                    ctx.lineTo(bps.p2.x, bps.p2.y);
                    ctx.lineWidth = linewidth;
                    ctx.strokeStyle = '#e0e0e0';
                    ctx.stroke();
                }
            }
        }
        if (!drawInstincts)
            return;
        // instincts
        let xstart = 232;
        // draw heading
        ctx.textAlign = "left";
        ctx.textBaseline = "top";
        ctx.font = `bold 58px ${chartFontName}`;
        //c.style.letterSpacing = "20px";
        ctx.fillText('INSTINCTS', xstart, 1775);
        // for each instinct
        let ins = ['SP', 'SO', 'SX'];
        let y = 1910;
        let barcolor = '#6d6e71';
        let textcolor = '#000000';
        for (let i in ins) {
            let instinct = ins[i];
            // draw instinct bars
            let score = normalize('s3', scores.main, instinct, scores.s3[instinct][4]);
            let len = 650 * score;
            let barthickness = 70;
            ctx.strokeStyle = barcolor;
            ctx.fillStyle = barcolor;
            roundedRect(ctx, xstart + 70, y - barthickness / 2, len, barthickness, 20);
            // draw instinct labels
            ctx.font = `bold 44px ${chartFontName}`;
            ctx.fillStyle = textcolor;
            ctx.strokeStyle = textcolor;
            ctx.textBaseline = 'middle';
            ctx.fillText(instinct, xstart, y + 8);
            y += 90;
        }
    }

    function idcanvas(ctx, c) {
        //ctx.fillStyle = "#d0d0d0";
        //ctx.fillRect(0, 0, c.width, c.height);  
    }

    function drawSocializationText(c, xc, yc, r, url, iw, ih, notEnglish, language, texts) {
        if (!c)
            return;
        const ctx = c.getContext("2d");
        idcanvas(ctx, c);
        const w = 2480;
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        const stationfontsize = w / 2 / 15;
        ctx.font = "normal normal " + stationfontsize + `px ${chartFontName}`;
        ctx.font = `800 80px ${chartFontName}`;
        ctx.textBaseline = 'middle';
        ctx.fillStyle = 'black';
        const img = new Image();
        if (!language)
            language = 'english';
        // language tweaking arrays:
        let ystarts = {
            english: [500,500,1600,1600],
            hungarian: [500,500,1550,1550],
            slovak: [500,500,1550,1550],
            afrikaans: [500,500,1550,1550],
            italian: [500,500,1550,1550],
            xhosa: [500,500,1550,1550],
            spanish: [500,500,1550,1550],
        }[language];
        let xstarts = {
            english: [700,1800,700,1800],
            hungarian: [1000,1400,1000,1400],
            slovak: [700,1800,700,1800],
            afrikaans: [700,1800,700,1800],
            italian: [700,1800,700,1800],
            xhosa: [700,1800,700,1800],
            spanish: [700,1800,700,1800],
        }[language];
        let aligns = {
            english: ['center','center','center','center'],
            hungarian: ['right','left','right','left'],
            slovak: ['center','center','center','center'],
            afrikaans: ['center','center','center','center'],
            italian: ['center','center','center','center'],
            xhosa: ['center','center','center','center'],
            spanish: ['center','center','center','center'],
        }[language]
        img.onload = () => {
            ctx.drawImage(img, 0, 0, iw, ih);
            let c = 0;
            for (let text of texts) {
                let lines = text.split('<br>');
                let y = ystarts[c];
                ctx.textAlign = aligns[c];
                for (let line of lines) {
                    let x = xstarts[c];
                    y+=100;
                    ctx.fillText(line, x, y);
                }
                c++;
            }
        }
        img.src = host + url
    }

    function drawEnneaNames(c, xc, yc, r, url, iw, ih, notEnglish) {
        if (!c)
            return;
        const ctx = c.getContext("2d");
        idcanvas(ctx, c);
        const w = 2480;
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        const stationfontsize = w / 2 / 15;
        ctx.font = "normal normal " + stationfontsize + `px ${chartFontName}`;
        ctx.font = `800 50px ${chartFontName}`;
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';
        ctx.fillStyle = 'black';
        const img = new Image();
        img.onload = () => {
            ctx.drawImage(img, 0, 0, iw, ih);
            if (!notEnglish)
                return;
            var enneaNames = [9, 1, 2, 3, 4, 5, 6, 7, 8].map(e => gEnneaNames[e]);
            for (let step = 0; step <= 1; step++) {
                let words = enneaNames.map(n => n.split(' ')[step]);
                let angle = 2 * Math.PI / 9;
                for (var i = 0; i < 9; i++) {
                    var radius = r + 175 + 30 - 60 * step;//ctx.measureText(words[0]).height*step;
                    ctx.save();
                    ctx.translate(xc, yc);
                    ctx.rotate(i * angle - (2 * Math.PI / 18));
                    var ra = 0;
                    for (let j = 0; j < words[i].length; j++) {
                        ra += ctx.measureText(words[i][j]).width * 0.001;
                    }
                    ra = 0 + ((2 * Math.PI / 9) - ra) / 2;
                    for (let j = 0; j < words[i].length; j++) {
                        ctx.save();
                        ctx.rotate(ra);
                        ctx.fillText(words[i][j], 0, -radius);
                        ra += ctx.measureText(words[i][j]).width * 0.001;
                        ctx.restore();
                    }
                    ctx.restore();
                }
            }
        }
        img.src = host + url
    }

    function drawIMFCoG(c, justText) {
        function roundedRightRect(ctx, x, y, w, h, r) {
            if (w < r) {
                w = r;
                r = r / 2;
            }
            ctx.beginPath();
            ctx.moveTo(x + r, y);
            ctx.arcTo(x + w, y, x + w, y + h, r);
            ctx.lineTo(x + w, y + h - r);
            ctx.arcTo(x + w, y + h, x, y + h, r);
            ctx.lineTo(x, y + h);
            ctx.lineTo(x, y);
            ctx.closePath();
            ctx.fill();
            ctx.stroke();
        }
        let levels = props.results.levels;
        let data = props.results.imfdata;
        if (!data.imfLevels)
            return;
        if (justText) {
            let a = [];
            for (let i = 0; i < 8; i++) {
                
                a.push({ name: data.imfLevels[i].name.toUpperCase(), score: levels[i] })
            }
            let s = <div className="a_paragraph">
                {a.map(k => <div>Stage {k.name} scores {k.score}</div>)}
            </div>
            return (s);
        }
        if (!c)
            return;
        const ctx = c.getContext("2d");
        idcanvas(ctx, c);
        let h = c.height;
        // draw label/bar dividing vertical line
        let xline = 487;
        let y1 = 145;
        let y2 = h - 55;
        ctx.lineWidth = 3; ctx.strokeStyle = '#505050'; ctx.setLineDash([]);
        ctx.beginPath(); ctx.moveTo(xline, y1); ctx.lineTo(xline, y2); ctx.closePath(); ctx.stroke();
        let xs = xline;
        let xtextbase = xline - 30;
        let xbarbase = xline + 14;
        let ystep = h / 9;
        if (levels.max % 2)
            levels.max += 1;
        else
            levels.max += 2;
        let fw = 1312;
        // draw nine vertical line divisions
        xs = xline;
        ctx.lineWidth = 1; ctx.strokeStyle = '#D0D0D0'; ctx.setLineDash([3, 5]);
        for (let i = 1; i <= 9; i++) {
            xs += 180;
            ctx.beginPath(); ctx.moveTo(xs, y1); ctx.lineTo(xs, y2); ctx.closePath(); ctx.stroke();
        }
        for (let i = 0; i < 8; i++) {
            let ys = h - ystep * 0.5 - i * ystep - 60;
            ctx.fillStyle = '#000000';
            ctx.textAlign = "right";
            ctx.textBaseline = "middle";
            ctx.font = `600 37px '${chartFontName}'`;
            ctx.fillText(data.imfLevels[i].name.toUpperCase(), xtextbase, ys);
            if (levels[i] > 0) {
                var barlength = fw * levels[i] / levels.max;
                var barthickness = 110;
                var cornerradius = 20;
                ctx.lineWidth = 1; ctx.strokeStyle = getMaturityColor(data.imfLevels[i].code); ctx.fillStyle = ctx.strokeStyle; ctx.setLineDash([]);
                roundedRightRect(ctx, xbarbase, ys - barthickness / 2 - 7, barlength, barthickness, cornerradius);
            }
        }
    }

    // Ported 1:1 (geometry, colors, timings) from public/newreports/imfnew/extras/chart-imfCoG-fan.js's
    // drawGradientFan(), which is what imfCS.htm uses to draw the 'cog_canvas' fan chart when coaching
    // suggestions are present. Kept intentionally identical to that file rather than reusing chartFontName
    // etc., since the goal here is pixel-parity with the PDF, not consistency with the rest of this component.
    async function drawGradientFan(canvas, svgUrls, fillPercentages, textPercentages, colors) {
        if (!canvas)
            return;
        const ctx = canvas.getContext("2d");

        const numPetals = 8;
        const L = canvas.height * 0.52; // petal major axis
        const W = L / 2.5; // petal minor axis
        const textFont = 'bold 34px sans-serif';
        const shiftX = 8;
        const textGapAboveTip = canvas.height * 0.045;
        const iconGapAboveText = canvas.height * 0.11;
        const iconSize = canvas.height * 0.15;

        const startAngleDeg = -169;
        const incrementDeg = 22.57;
        const zeroColor = '#E0E0E0';
        const baseColor = '#C0C0C0';

        // --- Pre-load SVG images ---
        const images = await Promise.all(svgUrls.map(src => {
            return new Promise((resolve) => {
                if (!src) return resolve(null);
                const img = new Image();
                img.onload = () => resolve(img);
                img.onerror = () => resolve(null);
                img.src = src;
            });
        }));

        // --- petal arc math ---
        const R = (L * L + W * W) / (4 * W);
        const Yc = R - (W / 2);

        // --- dynamic hub positioning: dock the outermost petals to the bottom of the canvas ---
        const startAngleRad = startAngleDeg * Math.PI / 180;
        const endAngleRad = (startAngleDeg + (numPetals - 1) * incrementDeg) * Math.PI / 180;

        const cyLeft = (L / 2) * Math.sin(startAngleRad) + Yc * Math.cos(startAngleRad);
        const dipLeft = cyLeft + R;

        const cyRight = (L / 2) * Math.sin(endAngleRad) - Yc * Math.cos(endAngleRad);
        const dipRight = cyRight + R;

        const maxDip = Math.max(dipLeft, dipRight);

        const hubX = canvas.width / 2 + shiftX;
        const hubY = canvas.height - maxDip - 2;

        // draw each petal
        for (let i = 0; i < numPetals; i++) {
            ctx.save();

            ctx.translate(hubX, hubY);
            const currentAngleDeg = startAngleDeg + (i * incrementDeg);
            const currentAngleRad = currentAngleDeg * Math.PI / 180;
            ctx.rotate(currentAngleRad);

            ctx.beginPath();

            const startAngleTop = Math.atan2(0 - Yc, 0 - L / 2);
            const endAngleTop = Math.atan2(0 - Yc, L - L / 2);
            ctx.arc(L / 2, Yc, R, startAngleTop, endAngleTop, false);

            const startAngleBot = Math.atan2(0 - (-Yc), L - L / 2);
            const endAngleBot = Math.atan2(0 - (-Yc), 0 - L / 2);
            ctx.arc(L / 2, -Yc, R, startAngleBot, endAngleBot, false);

            ctx.closePath();

            const p = Math.max(0, Math.min(100, fillPercentages[i])) / 100;

            let petalColor = colors[i];
            if (p === 0)
                petalColor = zeroColor;
            const gradient = ctx.createLinearGradient(0, 0, L, 0);
            const baseStopPosition = 1 - p;
            gradient.addColorStop(1, petalColor);
            gradient.addColorStop(baseStopPosition, baseColor);
            gradient.addColorStop(0, baseColor);
            ctx.fillStyle = gradient;

            ctx.fill();

            ctx.strokeStyle = '#FFFFFF';
            ctx.lineWidth = 4;
            ctx.stroke();

            ctx.restore(); // rotation cleared here

            // text and icons: global un-rotated coordinates, plotted radially
            if (textPercentages[i] > 0) {
                const textRadius = L + textGapAboveTip;
                const iconRadius = textRadius + iconGapAboveText;

                const textX = hubX + textRadius * Math.cos(currentAngleRad);
                const textY = hubY + textRadius * Math.sin(currentAngleRad);

                const iconX = hubX + iconRadius * Math.cos(currentAngleRad);
                const iconY = hubY + iconRadius * Math.sin(currentAngleRad);

                ctx.fillStyle = '#333333';
                ctx.font = textFont;
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                ctx.fillText(textPercentages[i] + '%', textX, textY);

                const img = images[i];
                if (img) {
                    ctx.drawImage(
                        img,
                        iconX - (iconSize / 2),
                        iconY - (iconSize / 2),
                        iconSize,
                        iconSize
                    );
                }
            }
        }

        // stage labels overlay (maturityfanlabels.svg), scaled/shifted to dock to the canvas bottom
        const labelImage = images[8];
        if (labelImage) {
            const scaleFactor = 1.17;
            const scaledWidth = canvas.width * scaleFactor;
            const scaledHeight = canvas.height * scaleFactor;
            const drawX = (canvas.width - scaledWidth) / 2;
            const drawY = canvas.height - scaledHeight;
            ctx.drawImage(labelImage, drawX, drawY, scaledWidth, scaledHeight);
        }
    }

    function drawIMFCoGFan(c) {
        let levels = props.results.levels;
        if (!levels)
            return;
        if (!c)
            return;
        const fillPercentages = [];
        const textPercentages = [];
        const colors = ['SE', 'CO', 'SP', 'PE', 'IN', 'ST', 'TR', 'BE'].map(getFanMaturityColor);
        let scores = [];
        for (let i = 0; i < 8; i++)
            scores.push(levels[i]);
        let maxScore = levels.max;
        const balancedTextPercentages = getPerfectPercentages(scores);
        for (let i = 0; i < 8; i++) {
            fillPercentages.push((scores[i] / maxScore) * 100);
            textPercentages.push(balancedTextPercentages[i]);
        }
        const svgUrls = Array.from({ length: 8 }, (_, i) => host + `newreports/imfnew/extras/eit${i + 1}.svg`);
        svgUrls.push(host + `newreports/imfnew/extras/maturityfanlabels.svg`);
        drawGradientFan(c, svgUrls, fillPercentages, textPercentages, colors);
    }

    function drawGraphs() {
        function paint() {
            window.requestAnimationFrame(() => {
                for (const cinfo of canvasList) {
                    let c = document.getElementById(cinfo.id);
                    if (c) {
                        cinfo.draw(c);
                    }
                }
            });
        }
        if (!document.fonts) {
            // Font Loading API unsupported: draw immediately, best effort.
            paint();
            return;
        }
        // Wait for the Quicksand webfont to actually be ready before painting.
        // Canvas text doesn't auto-repaint when a webfont finishes loading, so
        // drawing too early permanently bakes the fallback font into the bitmap.
        document.fonts.load(`16px ${chartFontName}`)
            .catch(() => { })
            .then(() => document.fonts.ready)
            .then(paint);
    }

    const [headerContent, setHeaderContent] = useState(<></>);
    const [canvasList] = useState([]);

    useEffect(() => {
        drawGraphs();
        // disable lint warning react-hooks/exhaustive-deps because of missing 'drawGraphs' in useEffect dependency array:
        // eslint-disable-next-line
    }, [props.results, props.refresher])

    useEffect(() => {
        function dangerDiv(html) {
            return (<div dangerouslySetInnerHTML={{ __html: html }}></div>)
        }
        function fill(value, field) {
            try {
                return (<div dangerouslySetInnerHTML={{ __html: rc[field][value] }}></div>)
            } catch (err) {
                return (<div>?</div>)
            }
        }
        function get(value, field, stripHtml) {
            if (!rc[field])
                return (null);
            return (strip(rc[field][value], stripHtml));
        }
        function fillStatic(field, stripHtml) {
            return (dangerDiv(getStatic(field, stripHtml)));
        }
        function strip(value, stripHtml) {
            if (!value)
                return (value);
            if (stripHtml) {
                if (value)
                    value = value.replaceAll('<br>', ' ');
            } else {
                if (value.includes('<br>')) {
                    value = ('<div class="a_paragraph">' + value + '</div>').replaceAll('<br><br>', '</div><div class="a_paragraph">');
                    value = value.replaceAll('<br>', ' ');
                }
            }
            return (value);
        }
        function fixTrifix(s) {
            return (s.replaceAll('-', '—'));
        }
        function getAndFillStatic(field, stripHtml, variable, val) {
            let s = strip(rc[field]['static'], stripHtml);
            return (s.replaceAll(variable, val));
        }
        function getAndFillStaticEx(field, stripHtml, variableArray, valArray) {
            let s = strip(rc[field]['static'], stripHtml);
            variableArray.forEach((v, i) => {
                s = s.replaceAll(v, valArray[i]);
            })
            return (s);
        }
        function getStaticPure(field) {
            if (!rc[field])
                return (null);
            return(rc[field]['static']);
        }
        function getStatic(field, stripHtml) {
            if (!rc[field])
                return (null);
            return (strip(rc[field]['static'], stripHtml));
        }
        function aephoriaCanvas(draw, width, height, alt) {
            if (onlyText)
                return (<></>)
            const id = 'canvas' + canvasList.length;
            canvasList.push({ draw: draw, id: id });
            return (<canvas
                aria-label={alt}
                id={id}
                width={width}
                height={height}
                style={{ maxWidth: "30em", width: '100%' }}>
            </canvas>)
        }
        function image(url, size, maxWidth, alt) {
            if (!size)
                size = '100%';
            if (!maxWidth)
                maxWidth = '100%';
            if (!alt)
                alt = '';
            if (onlyText)
                return (<></>)
            return (
                <img style={{ width: `${size}`, maxWidth: `${maxWidth}` }} alt={alt} src={host + url}></img>
            )
        }
        function table(rows, col1style, col2style) {
            if ((props.isNarrow) || (onlyText))
                return (tableMobile(rows, col1style, col2style));
            return (tableDesktop(rows, col1style, col2style));
        }
        function tableDesktop(rows, col1style, col2style) {
            return (
                <table>
                    <tbody>
                        {rows.map((row, index) =>
                            <tr key={index}>
                                <td style={col1style}>{row.col1}</td>
                                <td style={col2style}>{row.col2}</td>
                            </tr>
                        )}
                    </tbody>
                </table>)
        }
        function tableMobile(rows, col1style, col2style) {
            return (
                <div className="a_paragraph">
                    {rows.map((row, index) =>
                        <div className="a_paragraph" key={index}>
                            <h3>{row.col1}</h3>
                            <div>{row.col2}</div>
                        </div>
                    )}
                </div>)
        }
        function versionLink(text, textOnly) {
            let url = window.location.href.split('?')[0]+(textOnly?'?version=text':'')
            return(<a href={url}>{text}</a>)
        }
        function drawMaturitySpread() {
            return(<>
                {aephoriaCanvas((c) => { drawIMFCoG(c) }, 2268, 1547, 'Bar graph showing Maturity scores, for each of the eight maturity stages.')}
                {onlyText && <div>
                    <p>Here are your Maturity scores. They are listed in general order of the Maturity stage.</p>
                    {drawIMFCoG(null, true)}
                </div>}
            </>)
        }
        // Matches the 'cog_canvas' fan chart used by imfnew/imfCS.htm (the PDF template that's used
        // whenever coaching suggestions exist) instead of the bar chart used by plain imfnew/imf.htm.
        function drawMaturityFanSpread() {
            return(<>
                {aephoriaCanvas((c) => { drawIMFCoGFan(c) }, 2244, 1320, 'Fan chart showing Maturity scores, for each of the eight maturity stages.')}
                {onlyText && <div>
                    <p>Here are your Maturity scores. They are listed in general order of the Maturity stage.</p>
                    {drawIMFCoG(null, true)}
                </div>}
            </>)
        }
        function drawEnneaSpread() {
            return(<>
                {aephoriaCanvas((c) => { drawEnneaBar(c) }, 2480, 1566, 'Bar graph showing Enneagram scores, for each of the nine enneagram types.')}
                {onlyText && <div>
                    <p>The following scores are listed in order of their general gut, heart, head centres. These scores represent how much or how little each of the Enneagram styles are expressed in your
                    approach at this point in time.</p>
                    {drawEnneaBar(null, true)}
                </div>}
            </>)
        }
        function versionSwitch() {
            return(<>
                {!notEnglish&&!onlyText&&<p>
                    Note: this HTML report is also available in a {versionLink('text-only version, for better accessibility', true)}.
                </p>}
                {!notEnglish&&onlyText&&<p>
                    Note: This HTML report is also available in a {versionLink('version with graphics and layout design', false)}.
                </p>}
            </>)
        }



        const rc = props.reportContent;
        let a = props.assessment;
        const miniReport = a.miniGuest;
        const combinedplus = props.reportCode === 'cp';
        const notEnglish = props.notEnglish;
        const combined = props.reportCode === 'c';
        const basic = (props.reportCode === 'e') && !miniReport;
        const maturity = props.reportCode === 'm';
        const showIMf = maturity || combined || combinedplus;
        const showEnnea = basic || combined || combinedplus || miniReport;
        const imfMarked = (a.finalTPR);
        const onlyText = props.results.onlyText;

        [8, 9, 1, 2, 3, 4, 5, 6, 7].forEach(n => { gEnneaNames[n] = getStatic(`e${n}nothe`) });

        let sections = [];
        let headingSwap = {};
        //unused sections: registration, responsesEnnea, postsurvey
        if (miniReport) sections = [
            'overallResults',
            'yourEnneagramStyle',
            'enneaRelationshipsMini',
            'trifix'
        ];
        if (basic) sections = [
            'title',
            'introEnnea',
            'overallResults',
            'enneaIntro',
            'yourEnneagramStyle',
            'understandingYourEnneagramStyle',
            'socialization',
            'enneaRelationships',
            'instincts',
            'trifix',
            'developmentEnnea',
            'developmentWholeEnnea',
            'enneagramOverview',
            'enneaBar',
        ];
        if (maturity) sections = [
            'title',
            'introMaturity',
            'overallResults',
            'maturityIntro',
            'yourCentreOfGravity',
            'yourStageAtWork',
            'leadingEdge',
            'fallingBack',
            'developmentMaturity',
            'questions',
            'imfStages',
            'responsesMaturity'
        ];
        if (combined) {
            sections = [
                'title',
                'introCombined',
                'overallResults',
                'enneaIntro',
                'yourEnneagramStyle',
                'understandingYourEnneagramStyle',
                'socialization',
                'enneaRelationships',
                'instincts',
                'trifix',
                'maturityIntro',
                'yourCentreOfGravity',
                'leadingEdge',
                'fallingBack',
                'developmentEnnea',
                'developmentMaturity',
                'yourResults',
                'enneagramOverview',
                'imfStages',
            ];
            headingSwap = {
                developmentEnnea: 'Development Opportunities: Enneagram',
                developmentMaturity: 'Development Opportunities: Maturity',
                enneagramOverview: 'Appendix B: Enneagram Overview',
                imfStages: 'Appendix C: Maturity Stages'
            };
        };
        if (combinedplus) {
            sections = [
                'title',
                'intro',
                'intro2',
                'overallResults',
                'enneaIntro',
                'yourEnneagramStyle',
                'understandingYourEnneagramStyle',
                'socialization',
                'enneaRelationships',
                'instincts',
                'maturityIntro',
                'yourCentreOfGravity',
                'yourStageAtWork',
                'aimLevel',
                'aimLevel8',
                'developmentEnnea',
                'developmentMaturity',
                'questions',
                'enneagramOverview',
                'imfStages',
                'responsesMaturity',
            ];
            headingSwap = {
                developmentEnnea: 'Development Opportunities: Enneagram',
                developmentMaturity: 'Development Opportunities: Maturity',
                enneagramOverview: 'Appendix A: Enneagram Overview',
                imfStages: 'Appendix B: Maturity Stages',
                responsesMaturity: 'Appendix C: Your Responses'
            };
        }

        if (!a.userTriType)
            a.userTriType = '125';
        if (!a.orderedTriType)
            a.orderedTriType = '125';
        //if (!a.userInstinct)
        //    a.userInstinct = 'SX';
        if (!a.userEnnea)
            a.userEnnea = '1';
        if (!a.finalTPR)
            a.finalTPR = 3;
        const ennea = a.userEnnea;
        const instinct = a.userInstinct;
        const imfNumber = a.finalTPR;
        const imf = maturityStages[a.finalTPR];
        let imfBackwardNumber = parseInt(a.finalTPR) - 1;
        if (imfBackwardNumber < 1)
            imfBackwardNumber = 1;
        let imfForwardNumber = parseInt(a.finalTPR) + 1;
        if (imfForwardNumber > 8)
            imfForwardNumber = 8;
        const imfForward = maturityStages[imfForwardNumber];
        const imfBackward = maturityStages[imfBackwardNumber];
        const trifix = a.userTriType.split('').sort().join('')
        let gutStyle = 8;
        if (trifix.includes('9')) gutStyle = 9;
        if (trifix.includes('1')) gutStyle = 1;
        let heartStyle = 2;
        if (trifix.includes('3')) heartStyle = 3;
        if (trifix.includes('4')) heartStyle = 4;
        let headStyle = 5;
        if (trifix.includes('6')) headStyle = 6;
        if (trifix.includes('7')) headStyle = 7;
        const orderedTrifix = a.orderedTriType.split('').join(' — ');
        const aim = (combinedplus) ? ((parseInt(a.userEnnea) - 1) * 8 + parseInt(a.finalTPR)) : 0;

        let tabs = [];
        function addSection(id, name, content) {
            if (headingSwap[id])
                name = headingSwap[id];
            if (!notEnglish) {
                name = name.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.substring(1)).join(' ');
                name = name.split('(').map(word => word.charAt(0).toUpperCase() + word.substring(1)).join('(');
            }
            let show = sections.includes(id);
            if (!show)
                return;
            let tab = { isSection: true, id: id, name: name, content: content };
            tabs.push(tab)
        }

        setHeaderContent(<>
        </>);

        (onlyText||props.isNarrow)&&addSection('title', '', <>
            <h1>{`${props.reportName} for ${a.userName} ${a.userSurname}`}</h1>
            <div className="resultDiv">
                {/*<span className='result'><b>{props.assessmentName}</b></span>*/}
                <span className='result'><b>{a.userEmail}</b></span>
                <span className='result'><b>{a.completedAt.substring(0, 10)}</b></span>
            </div>
            {/*
            {showEnnea && <div className="resultDiv">
                <span className='result'>Ennea: <b>{a.userEnnea}</b> {a.userInstinct && !props.isNarrow && <span>Instinct:</span>} <b>{a.userInstinct}</b></span>
                <span className='result'>Trifix: <b>{rc.trifixName[trifix]} ({a.orderedTriType})</b></span>
            </div>}
            {showIMf && <div className="resultDiv">
                <span className='result'>Maturity: <b>{imf}</b></span>
                {combinedplus && <span className='result'>AIM: <b>{rc.aIMLevelName[aim]}</b></span>}
            </div>}
            */}
        </>);

        addSection('introEnnea', getStatic('p2heading', true), <>
            {versionSwitch()}
            <p>
                {fillStatic('introCol1b')}
            </p>
            <p>
                {fillStatic('introCol2b')}
            </p>
        </>);

        addSection('introMaturity', 'Introduction to this report and where it will be useful to you', <>
            {versionSwitch()}
            <p>
                {fillStatic('introCol1imf')}
            </p>
            <p>
                {fillStatic('introCol2imf')}
            </p>
        </>);

        addSection('introCombined', 'Introduction to this report and where it will be useful to you', <>
            {versionSwitch()}
            <p>
                {fillStatic('introCol1f')}
            </p><p>
                {fillStatic('introCol2f')}
            </p>
        </>);

        addSection('intro', 'How Do I Use My Results To Develop and Mature?', <>
            {versionSwitch()}
            <p>
                {fillStatic('introTope')}
            </p><p>
                {fillStatic('introCol1e')}
            </p><p>
                {fillStatic('introCol2e')}
            </p>
        </>);

        addSection('intro2', 'Introduction to this Assessment and its Components', <>
            <div>
                <p>
                    {fillStatic('introCol1Ae')}
                </p><p>
                    {fillStatic('introCol2Ae')}
                </p>
            </div>
            {image(`newreports/bfe/extras/Extended/Aephoria_Extended Report_SEPT 2024_p3-3-01NEW.svg`, '100%')}
        </>);

        addSection('overallResults', getStatic('p3heading', true), <>
            {[
                {
                    show: showEnnea, heading: getStatic('p3subheading1', true),
                    image: `newreports/bfe/extras/Extended/Aephoria_Extended Report_graphics-${ennea}.svg`,
                    alt: 'Enneagram icon',
                    name: !onlyText ? `<b>${showEnnea && rc.eheading[ennea]}: ${showEnnea && rc.enneagramName[ennea]}</b>` :
                        `<b>${showEnnea && rc.eheading[ennea]}: ${showEnnea && rc.enneagramName[ennea]}</b>`,
                    description: showEnnea && rc.enneagramMainStyle[ennea]
                },
                {
                    show: showEnnea && !combinedplus, heading: getStatic('p3subheading2', true),
                    image: `newreports/bfe/extras/trifix.svg`,
                    alt: 'Trifix icon',
                    name: !onlyText ? `<b>${orderedTrifix}: ${rc.trifixName[trifix]}</b>` :
                        `<b>${orderedTrifix}: ${rc.trifixName[trifix]}</b>`,
                    description: rc.trifixDescription[trifix]
                },
                {
                    show: showEnnea && instinct, heading: getStatic('p3subheading3', true),
                    image: `newreports/bfe/extras/Extended/Aephoria_Extended Report_p10_${instinct}.svg`,
                    alt: 'Instinct icon',
                    name: `<b>${showEnnea && instinct && rc.instinctTitle[instinct]}</b>`,
                    description: showEnnea && instinct && rc.instinctSummary[instinct]
                },
                {
                    show: showIMf, heading: 'Maturity Centre of Gravity',
                    image: `newreports/bfe/extras/Extended/Aephoria_Extended Report_graphics-IMF stages-${imfNumber}.svg`,
                    alt: 'Maturity icon',
                    name: `<b>${imf}</b>`,
                    description: showIMf && rc.coGText[imf]
                },
                {
                    show: showIMf && showEnnea && combinedplus, heading: 'Combined Map',
                    image: `newreports/bfe/extras/72icons/Aephoria_Index_icons-${aim.toString().padStart(2, '0')}.svg`,
                    alt: 'Combined icon',
                    name: `<b>${showIMf && showEnnea && rc.aIMLevelName[aim]}</b>`,
                    description: showIMf && showEnnea && rc.aIMLevelDescriptionII[aim]
                },
            ].map((r, index) => <div key={index}>
                {r.show && <div className={(onlyText||props.isNarrow) ? "" : "overallResults"}>
                    <h3>{r.heading}</h3>
                    {onlyText ? <div>
                        <div style={{ textTransform: "uppercase" }}>{dangerDiv(r.name)}</div>
                        <div>{r.description}</div>
                    </div> : <>{table([{
                            col1:<>{image(r.image, '100px', '100px', r.alt)}</>,
                            col2:<><div style={{ textTransform: "uppercase" }}>{dangerDiv(r.name)}</div>
                                <div>{r.description}</div></>
                        }])}</>}

                </div>}
            </div>)}
            {maturity && <>
                <div className={`resultsCanvas ${props.results.coachingSuggestions ? "maturityFanResults" : ""}`}>
                    {props.results.coachingSuggestions
                        ? drawMaturityFanSpread()
                        : drawMaturitySpread()}
                </div>
                {props.results.coachingSuggestions && <>
                    <h3>Summary of patterns and themes</h3>
                    <div className={(onlyText||props.isNarrow) ? "" : "csPatternsCols"}>
                        {dangerDiv(props.results.coachingSuggestions.patterns123)}
                        {dangerDiv(props.results.coachingSuggestions.patterns45)}
                    </div>
                </>}
            </>}
        </>);

        addSection('enneaIntro', getStatic('p4heading'), <>
            {dangerDiv(strip(getStaticPure('whatCol1')+' '+getStaticPure('whatCol2'),false))}
            <p>
                "{getStatic('perspective', true)}"
            </p>
            {aephoriaCanvas((c) => { drawEnneaNames(c, 1234, 1244, 950, `newreports/bfe/extras/enneasymbol${notEnglish ? 'blank' : ''}.svg`, 2480, 2480, notEnglish) }, 2480, 2480, 'Enneagram symbol')}
            {onlyText && <div class="a_paragraph">
                <h3>The Enneagram Symbol</h3>
                <p>The Enneagram symbol shows nine points spaced equally around a circle.</p>
                <p>Each point represents one of the Enneagram styles, starting with Style 9 at the top of the circle, going clockwise:
                    <div>Style 9, the Adaptive Diplomat.</div>
                    <div>Style 1, the Meticulous Judge, </div>
                    <div>Style 2, the Supportive Cheerleader, </div>
                    <div>Style 3, the Ambitious Taskmaster, </div>
                    <div>Style 4, the Sensitive Maverick, </div>
                    <div>Style 5, the Expert Observer, </div>
                    <div>Style 6, the Vigilant Questioner, </div>
                    <div>Style 7, the Positive Dreamer, </div>
                    <div>Style 8, the Tough Protector, </div>
                </p>
                <p>
                    The styles are grouped into three centres - the Gut, Heart, and Head centres.
                    <div>The Gut Centre consists of Styles 8, 9, and 1.</div>
                    <div>The Heart Centre consists of Styles 2, 3, and 4.</div>
                    <div>The Head Centre consists of Styles 5, 6, and 7.</div>
                </p>
                <p>A set of lines connect the points to each other:
                    <div>9 is connected to 3 and 6.</div>
                    <div>1 is connected to 4 and 7;</div>
                    <div>2 is connected to 4 and 8;</div>
                    <div>3 is connected to 6 and 9;</div>
                    <div>4 is connected to 1 and 2;</div>
                    <div>5 is connected to 7 and 8;</div>
                    <div>6 is connected to 3 and 9;</div>
                    <div>7 is connected to 1 and 5;</div>
                    <div>8 is connected to 2 and 5.</div>
                </p>
            </div>}
        </>);

        addSection('yourEnneagramStyle', getStatic(miniReport ? 'p5subheading1' : 'p5heading', true), <>
            {!miniReport && <h3>{getStatic('p5subheading1', true)}</h3>}
            {!onlyText && <div style={{ textAlign: "center", width: "fit-content" }}>
                {!miniReport && image(`newreports/bfe/extras/Extended/Aephoria_Extended Report_graphics-${ennea}.svg`, '150px', null, 'Enneagram icon')}
                <div style={{ textTransform: "uppercase" }}><b>{get(ennea, 'enneagramName')}</b></div>
            </div>}
            {onlyText && <div>
                <div style={{ textTransform: "uppercase" }}><b>Enneagram {ennea}: {get(ennea, 'enneagramName')}</b></div>
            </div>}
            <p>
                "{get(ennea, 'motivationQuote')}"
            </p>            
            <p>
                {fill(ennea, 'yourEnneagramStyle')}
            </p>
            {!miniReport && aephoriaCanvas((c) => { drawEnneaNames(c, 1228, 1238, 950, `newreports/bfe/extras/Enneagram${notEnglish ? 'blank' : ''}_-0${props.assessment.userEnnea}.svg`, 2480, 2480, notEnglish) }, 2480, 2480, 'Enneagram symbol with your enneagram position highlighted')}
        </>);
        
        addSection('understandingYourEnneagramStyle', getStatic('tc6'), <>
            {fillStatic('styleIntro')}
            {table([/*table-enneaAspects*/
                { col1: getStatic('p6c1'), col2: fill(ennea, 'motivation') },
                { col1: getStatic('p6c2'), col2: fill(ennea, 'strengths') },
                { col1: getStatic('p6c3'), col2: fill(ennea, 'worldview') },
                { col1: getStatic('p6c4'), col2: fill(ennea, 'messageToTheWorld') },
                { col1: getStatic('p6c5'), col2: fill(ennea, 'messageToSelf') },
                { col1: getStatic('p6c6'), col2: fill(ennea, 'howIFeelInside') },
                { col1: getStatic('p6c7'), col2: fill(ennea, 'defenceMechanism') },
                { col1: getStatic('p6c8'), col2: fill(ennea, 'keyPatterns') },
                { col1: getStatic('p6c9'), col2: fill(ennea, 'reflection') },
            ])}
        </>);
        
        addSection('socialization', getStatic('p7heading', true), <>
            {fillStatic('p7col1')}
            <p>
                {aephoriaCanvas((c) => { drawSocializationText(c, 1234, 1244, 950, `newreports/bfe/extras/Extended/Aephoroa_Extended_Report_p8_process diagram.svg`, 2480, 2480, notEnglish, props.reportLanguage, 'pd1,pd2,pd3,pd4'.split(',').map(i=>getStaticPure(i))) }, 2480, 2480, `
                A circular image with four quadrants. Each quadrant is labelled, and there are arrows flowing from one quadrant to the next.
                The labels of each of the quadrants are,
                1) Birth and life in my unique context,
                2) Failures in holding environment,
                3) Loss of trust shapes how I believe I will get the love I need,
                4) Ideas become fixated as a motivation and worldview`)}
                {onlyText && <p>
                    <li>Birth and life in my unique context</li>
                    <li>not having all my needs met,</li>
                    <li>leads to loss of trust shaping how I believe I will get the love I need,</li>
                    <li>and ideas become fixated as a motivation and worldview</li>
                </p>}
                {dangerDiv(getStatic('p7col2').replace('$ennea', ennea))}
            </p><p>
                {fill(ennea, 'socialisationAndYourEnneagramStyle')}
            </p><p>
                <div>{fillStatic('p7col2b')}</div>
            </p>
        </>);
        
        addSection('enneaRelationships', getStatic('p8heading', true), <>
            {fillStatic('p8col1')}
            <p>
                {fillStatic('p8col2')}
            </p>
            {table([/*table-enneaRelations*/
                { col1: getStatic('p8h1', true), col2: fill(ennea, 'howToGetAlongWithMeInGeneral') },
                { col1: getStatic('p8h2', true), col2: fill(ennea, 'howToManageMeAsYourEmployee') },
                { col1: getStatic('p8h3', true), col2: fill(ennea, 'leadershipBlindspotsToSupportMeWith') },
            ], { width: '10em' })}
            {(onlyText||(props.isNarrow))&&<h3>Reflection</h3>}
            <p>
                {fillStatic('p8reflect')}
            </p>
            {fill(ennea, 'reflectionsOnRelationshipsLeftColumn')}
            {fill(ennea, 'reflectionsOnRelationshipsRightColumn')}
        </>);
        
        addSection('enneaRelationshipsMini', getStatic('p8heading', true), <>
            {table([/*table-enneaRelations*/
                { col1: getStatic('p8h2', true), col2: fill(ennea, 'howToManageMeAsYourEmployee') },
                { col1: getStatic('p8h3', true), col2: fill(ennea, 'leadershipBlindspotsToSupportMeWith') },
            ], { width: '10em', color: "white" })}
        </>);
        
        addSection('instincts', getStatic('p9heading'), <>
            {fillStatic('p9col1')}
            <p>
                {fillStatic('p9col2')}
            </p>

            {[
                {
                    image: `newreports/bfe/extras/Extended/Aephoria_Extended Report_p10_SP.svg`,
                    name: 'p9sph',
                    content: 'p9spc'
                },
                {
                    image: `newreports/bfe/extras/Extended/Aephoria_Extended Report_p10_SO.svg`,
                    name: 'p9soh',
                    content: 'p9soc'
                },
                {
                    image: `newreports/bfe/extras/Extended/Aephoria_Extended Report_p10_SX.svg`,
                    name: 'p9sxh',
                    content: 'p9sxc'
                },
            ].map((r, index) => <div key={index}>
                {onlyText ? <>
                    <h3><b>{getStatic(r.name)}</b></h3>
                    <div>{fillStatic(r.content)}</div>
                </> : <>
                    {table([
                        {col1:<>{image(r.image, '100px', '100px', 'instinct icon')}</>, col2:<><div style={{ textTransform: "uppercase" }}><b>{getStatic(r.name)}</b></div>
                                <div>{fillStatic(r.content)}</div></>}
                    ])}
                </>}
            </div>)}
            {onlyText&&<>
                <h3>Your Instinct Scores</h3>
                <p>Scores are listed in order of Self-Preservation, Social, and One-on-One:</p>
                {onlyText && drawInstincts(null, true)}
            </>}
            <h3>{get(instinct, 'yourInstinct')}</h3>
            {aephoriaCanvas((c) => { drawInstincts(c, false, notEnglish, props.reportLanguage, 'sp,so,sx'.split(',').map(i=>getStaticPure(i))) }, 1280, 308, 'Bar graph showing scores for the three instincts.')}
            {fill(ennea, 'yourInstinctIs' + instinct)}
        </>);
        
        addSection('trifix', getStatic('p10heading', true), <>
            {!miniReport && <p>{fillStatic('p10intro')}</p>}
            <>
                <div><b>{fixTrifix(getAndFillStaticEx('yourTrifixIs', true, ['$triMax', '$triMiddle', '$triMin'], [a.orderedTriType[0], a.orderedTriType[1], a.orderedTriType[2]]))}</b><p style={{ textTransform: "uppercase" }}>{get(trifix, 'trifixName')}</p></div>
                <p>
                    {fill(trifix, 'trifixDescription')}
                </p>
            </>
            <b>{getAndFillStatic('gutStyleH', true, '$gutEnnea', gutStyle)}</b>
            {fill(gutStyle, 'trifixCenterStyle')}
            <p>
                <b>{getAndFillStatic('heartStyleH', true, '$heartEnnea', heartStyle)}</b>
                {fill(heartStyle, 'trifixCenterStyle')}
            </p>
            <b>{getAndFillStatic('headStyleH', true, '$headEnnea', headStyle)}</b>
            {fill(headStyle, 'trifixCenterStyle')}
            {!miniReport && <>
                {/*aephoriaCanvas((c)=>{drawTripleBars(c)}, 1280, 1320)*/}
            </>}
            <p>
                {fill(trifix, 'gutHeartHeadPattern1')}
            </p>
            <p>
                {fill(trifix, 'gutHeartHeadPattern2')}
            </p>
        </>);
        
        addSection('developmentEnnea', getStatic('p11heading'), <>
            <h3>{get(ennea, 'p11subheading1')}</h3>
            <div style={{ textTransform: "uppercase" }}>
                <b>{get(ennea, 'eheading')}</b> {get(ennea, 'enneagramName')}
            </div>
            {fill(ennea, 'usingTheEnneagramForDevelopment')}
            <h3>{getStatic('p11subheading2')}</h3>
            <p>
                {fillStatic('p11intro')}
            </p><p>
                {fillStatic('p11introRight')}
            </p><p>
                {fill(ennea, 'polarityLastSentenceOfParagraph')}
            </p>
            <h3>{get(ennea, 'p11subheading3')}</h3>
            <p>"{get(ennea, 'polarityQuote', true)}"</p>
            {'1234'.split('').map((n, index) => <div key={index}>
                {get(ennea, 'polarity' + n + 'A')} - {get(ennea, 'polarity' + n + 'B')}
            </div>)}
        </>);
        
        addSection('developmentWholeEnnea', getStatic('p12heading', true), <>
            {fillStatic('p12intro')}
            <div className="a_paragraph">
                {aephoriaCanvas((c) => { drawEnneaWingsLines(c) }, 2480, 2480, 'Enneagram symbol showing the wings and lines for your enneagram type.')}
                {onlyText && <>
                    {ennea === '8' && <div>In the Enneagram symbol, the 8 is neighboured by its Wings, 7 and 9, and connected to its Lines, 2 and 5.</div>}
                    {ennea === '9' && <div>In the Enneagram symbol, the 9 is neighboured by its Wings, 8 and 1, and connected to its Lines, 3 and 6.</div>}
                    {ennea === '1' && <div>In the Enneagram symbol, the 1 is neighboured by its Wings, 9 and 2, and connected to its Lines, 4 and 7.</div>}
                    {ennea === '2' && <div>In the Enneagram symbol, the 2 is neighboured by its Wings, 1 and 3, and connected to its Lines, 4 and 8.</div>}
                    {ennea === '3' && <div>In the Enneagram symbol, the 3 is neighboured by its Wings, 2 and 4, and connected to its Lines, 6 and 9.</div>}
                    {ennea === '4' && <div>In the Enneagram symbol, the 4 is neighboured by its Wings, 3 and 5, and connected to its Lines, 1 and 2.</div>}
                    {ennea === '5' && <div>In the Enneagram symbol, the 5 is neighboured by its Wings, 4 and 6, and connected to its Lines, 7 and 8.</div>}
                    {ennea === '6' && <div>In the Enneagram symbol, the 6 is neighboured by its Wings, 5 and 7, and connected to its Lines, 3 and 9.</div>}
                    {ennea === '7' && <div>In the Enneagram symbol, the 7 is neighboured by its Wings, 6 and 8, and connected to its Lines, 1 and 5.</div>}
                </>}
            </div>
            {table([/*table-wingline*/
                { col1: get(ennea, 'wing1Heading'), col2: fill(ennea, 'developWing1') },
                { col1: get(ennea, 'wing2Heading'), col2: fill(ennea, 'developWing2') },
                { col1: get(ennea, 'line1Heading'), col2: fill(ennea, 'developLine1') },
                { col1: get(ennea, 'line2Heading'), col2: fill(ennea, 'developLine2') },
            ], { width: '10em' })}
        </>);
        
        addSection('enneagramOverview', getStatic('p13heading'), <>
            <h3>{getStatic('p13subheading')}</h3>
            <p>
                {fillStatic('p13intro')}
            </p>
            <div>
                {image('newreports/bfe/extras/Basic_Report_icon_p13_gut.svg', '150px', null, 'Gut centre icon')}
            </div>
            <h4 style={{ textTransform: "uppercase" }}>{getStatic('p13hgut', true)}</h4>
            <p>
                Enneagram 8 {fillStatic('e8')}
                {fillStatic('p13e8')}
            </p><p>
                Enneagram 9 {fillStatic('e9')}
                {fillStatic('p13e9')}
            </p><p>
                Enneagram 1 {fillStatic('e1')}
                {fillStatic('p13e1')}
            </p>

            <div>
                {image('newreports/bfe/extras/Basic_Report_icon_p13_heart.svg', '150px', null, 'Heart centre icon')}
            </div>
            <h4 style={{ textTransform: "uppercase" }}>{getStatic('p13hheart', true)}</h4>
            <p>
                Enneagram 2 {fillStatic('e2')}
                {fillStatic('p13e2')}
            </p><p>
                Enneagram 3 {fillStatic('e3')}
                {fillStatic('p13e3')}
            </p><p>
                Enneagram 4 {fillStatic('e4')}
                {fillStatic('p13e4')}
            </p>


            <div>
                {image('newreports/bfe/extras/Basic_Report_icon_p13_head.svg', '150px', null, 'Head centre icon')}
            </div>
            <h4 style={{ textTransform: "uppercase" }}>{getStatic('p13hhead', true)}</h4>
            <p>
                Enneagram 5 {fillStatic('e5')}
                {fillStatic('p13e5')}
            </p><p>
                Enneagram 6 {fillStatic('e6')}
                {fillStatic('p13e6')}
            </p><p>
                Enneagram 7 {fillStatic('e7')}
                {fillStatic('p13e7')}
            </p>

        </>);

        addSection('enneaBar', getStatic('p14heading', true), <>
            {!onlyText && fillStatic('p14intro')}
            <div className="a_paragraph">
                {drawEnneaSpread()}
            </div>
            {/*aephoriaCanvas((c)=>{drawEnneaRose(c, false)}, 2480, 2480)*/}
        </>);

        addSection('yourResults', 'Appendix A: Your Results', <>
            <h3>Your Enneagram Spread</h3>
            {fillStatic('p14intro')}
            {drawEnneaSpread()}
            <h3>Maturity centre of gravity</h3>
            <div>
                {image(`newreports/bfe/extras/Extended/Aephoria_Extended Report_graphics-IMF stages-${imfNumber}.svg`, '150px')}
                <div style={{ textTransform: "uppercase" }}><b>{imf} STAGE</b></div>
                "{get(imf, 'coGQuoteBody', true)}"
            </div>
            {drawMaturitySpread()}
        </>);

        addSection('maturityIntro', 'What is Maturity?', <>
            <h3>The journey of adult development</h3>
            <p>
                {fillStatic('p11textf')}
            </p>
            {image(`newreports/imfnew/extras/maturityfan.svg`, '100%')}
            {onlyText && <div class="a_paragraph">
                <p>Here are the stages of maturity:</p>
                {'SE,CO,SP,PE,IN,ST,TR,BE'.split(',').map((code,index)=>{
                    return(
                    <>
                        <p><b className="upperCase">{maturityStages[index+1]}</b>: {getStatic('motto'+code)}</p>
                    </>
                )})}
            </div>}

            {!combined && <>
                <h3>A centre of gravity at a point in time</h3>
                {fillStatic('coGCol1')}
                {fillStatic('coGCol2')}
                <h3>How it is measured</h3>
                {fillStatic('measuredCol1')}
                {fillStatic('measuredCol2')}
            </>}
        </>)
        
        addSection('yourCentreOfGravity', 'Understanding Your Maturity Range', <>
            <h3>Your centre of gravity</h3>
            <div style={{ textAlign: "center", width: "fit-content" }}>
                {image(`newreports/bfe/extras/Extended/Aephoria_Extended Report_graphics-IMF stages-${imfNumber}.svg`, '150px')}
                <div style={{ textTransform: "uppercase" }}><b>{imf} STAGE</b></div>
            </div>
            <p>
            "{get(imf, 'coGQuoteBody', true)}"
            </p>
            <div>{dangerDiv(get(imf, 'identityStageSummary'))}</div>
            {table([/*table-imfAspects*/
                { col1: 'Outer Life', col2: fill(imf, 'outerLife') },
                { col1: 'Inner Life', col2: fill(imf, 'innerLife') },
                { col1: 'Sense of personal power and freedom', col2: fill(imf, 'senseOfPersonalPower') },
                { col1: 'Leaders at this stage', col2: fill(imf, 'leaders') },
                { col1: 'Followers at this stage', col2: fill(imf, 'followers') },
            ])}
        </>);
        
        addSection('yourStageAtWork', 'Your Stage At Work', <>
                <h3>How to be with me at this stage</h3>
                {table([/*table-imfWork*/
                    { col1: 'How to get along with me in general', col2: fill(imf, 'howToBeGeneral') },
                    { col1: 'How to manage me as your employee', col2: fill(imf, 'howToBeMyEmployer') },
                    { col1: 'What I expect from you as your leader', col2: fill(imf, 'howToBeMyFollower') },
                ], { width: '10em' })}
                <h3>Exploring leadership</h3>
                <div className="a_paragraph">You defined leadership in the following way when completing the sentences:</div>
                {props.results && showIMf && <div className="a_paragraph"><b><i>
                    "Leadership {props.results.gresponses.find(gr => ((gr.QuestionNumber === 13) && (gr.SectionId === 4))).RawTextResponse}"
                </i></b></div>}
                <div className="a_paragraph">You may want to consider how people at different stages of Maturity define leadership and reflect on the implications of these definitions to help you expand your leadership identity.</div>
                {fill(imf, 'defineLeadershipCol1')}
                {fill(imf, 'defineLeadershipCol2')}
                {fill(imf, 'leadershipSuggestions')}
            </>);
        addSection('leadingEdge', 'Leading Edge', <>
                <h3>Expanding and growing</h3>
                <div className="a_paragraph">
                    The {imf} stage is your centre of gravity but you don't spend all your time expressing this stage.
                    Given your results you may find that you are, in your best moments and at a stretched capacity, able to access the <b>{imfForward} Stage</b>.
                </div>
                <div className="a_paragraph" style={{ textTransform: "uppercase" }}></div>
                {dangerDiv(get(imf, 'leadershipExpansion'))}
                <div className="a_paragraph">{fillStatic('leadershipExpansionSuggestionsPreamble')}</div>
                <div className="a_paragraph">{fill(imf, 'leadershipExpansionSuggestions')}</div>
            </>);
        addSection('fallingBack', 'Falling Back', <>
                <h3>Acting from an earlier stage</h3>
                <p>
                    Fallback is a constriction of capacity, where the highest stage of Maturity you act, feel, and think into becomes
                    unavailable to you. It is not operating from an earlier stage of Maturation as a
                    constructive adaptation to the environment, but the process where you lose your ability to see, feel, reason and
                    act in a way you were able to before. This kind of fallback may be triggered by:
                    <ul>
                        <li>Ordinary triggers in response to the complex, stressful world we live in and trigger behavioural and
                            physiological brain responses that block our access to a more mature response</li>
                        <li>Contextual gravitational pulls that lead to us operating in tune with a less mature environment</li>
                        <li>Challenges to your identity that unsettle your ability to make meaning, some of these may be in the
                            form of major life changes that reshape who we are in the world</li>
                        <li>Unresolved trauma</li>
                    </ul>
                    When we fall back in our own maturation journey, we may fall all the way to the pre-conventional level.
                    Given the spread of your sentences, you need to be particularly conscious of
                    falling back to the <b>{imfBackward}</b> level.
                </p>
                {dangerDiv(get(imf, 'leadershipFallback'))}
        </>);
        
        addSection('developmentMaturity', 'Development Opportunities', <>
            {props.results.coachingSuggestions && <>
                <h3>Personalised development priorities</h3>
                <div className="developmentEdge">{dangerDiv(props.results.coachingSuggestions.developmentEdge)}</div>
            </>}
            <h3>What keeps me stuck in general</h3>
            {fill(imf, 'keepsMyIdentityStuck')}
            <h3>What expands me in general</h3>
            {fill(imf, 'expandsMyIdentity')}
        </>);

        addSection('questions', 'Questions and Themes for Reflection', <>
            {props.results.coachingSuggestions ? <>
                <h3>Personalised coaching notes</h3>
                <div className="personalisedNotes">{dangerDiv(props.results.coachingSuggestions.coachingNotes)}</div>
                <h3>General coaching notes</h3>
                <p>You may want to reflect on and work with your coach on some of the following questions in support of your development journey and maturation.</p>
                {fill(imf, 'reflectionsForCS')}
            </> : <>
                <p>You may want to reflect on and work with your coach on some of the following questions in support of your development journey and maturation.</p>
                {fill(imf, 'reflectionsCol1')}
                {fill(imf, 'reflectionsCol2')}
            </>}
        </>);
        
        addSection('imfStages', 'Appendix A: Maturity Stages', <>
            {image(`newreports/bfe/extras/MaturityStages.svg`, '100%')}
            {onlyText && <div class="a_paragraph">
                <p>Here are the stages of maturity. Each stage is either out the group or in the group.</p>
                {'SE,CO,SP,PE,IN,ST,TR,BE'.split(',').map((code,index)=>{return(
                    <>
                        <p>
                        <b className="upperCase">{maturityStages[index+1]}</b><br></br>
                        ({(index%2===0)?'Out the group':'In the group'})<br></br>
                        <span className="capitalize">{getStatic('motto'+code)}</span><br></br>
                        {getStatic('motiv'+code)}
                        </p>
                    </>
                )})}
            </div>}
        </>);

        addSection('aimLevel', 'Combined Map (Enneagram + Maturity)', <>
            <div style={{ textAlign: "center", width: "fit-content" }}>
                {image(`newreports/bfe/extras/72icons/Aephoria_Index_icons-${aim.toString().padStart(2, '0')}.svg`, '150px')}
                <div style={{ textTransform: "uppercase" }}><b>{get(aim, 'aIMLevelName')}</b></div>
            </div>
            <h3>Description</h3>
            <div className="a_paragraph">{dangerDiv(get(aim, 'aIMLevelDescriptionII'))}</div>
            <div className="a_paragraph">{dangerDiv(get(aim, 'aIMLevelDescription'))}</div>
            <h3>How it feels on the inside</h3>
            {fill(aim, 'howItFeelsOnTheInside')}
        </>);
        
        addSection('aimLevel8', 'The Stages of your Enneagram Style', <>
            {table(/*table-aimLevels*/
                maturityCodes.filter(c => c).map((code, index) => {
                    let cOde = code.charAt(0).toLowerCase() + code.slice(1);
                    return (
                        { col1: maturityStages[index + 1], col2: <><b>{get(ennea, cOde + 'LevelName')}:</b> {get(ennea, cOde + 'LevelCatchPhrase')}</> }
                    )
                })
            )}
            <h3>Enneagram {ennea} influence</h3>
            {fill(ennea, 'enneagramInfluence')}
            <h3>{imf} stage influence</h3>
            {fill(imf, 'maturityInfluence')}
        </>);
        
        addSection('registration', 'Registration Details', <>
            <div class="registrationSection">
                <div>
                    <label>Registered: <b>{a.completedAt.substring(0, 10)}</b></label>
                </div>
                <div>
                    <label>Name: <b>{a.userName}</b></label>
                </div>
                <div>
                    <label>Surname: <b>{a.userSurname}</b></label>
                </div>
                <div>
                    <label>Email: <b>{a.userEmail}</b></label>
                </div>
                <div>
                    <label>Company/Organisation: <b>{a.userCompany}</b></label>
                </div>
                <div>
                    <label>Position/Role: <b>{a.userOccupation}</b></label>
                </div>
                <div>
                    <label>Gender: <b>{a.userGender}</b></label>
                </div>
                <div>
                    <label>Date of Birth: <b>{a.userDateOfBirth}</b></label>
                </div>
            </div>
        </>);

        addSection('responsesEnnea', 'Enneagram Responses', <>
            {props.results && <>
                {props.results.gresponses.filter(gr => gr.SectionId < 4).map((gr, index) => {
                    return (<div key={index}>
                        {(gr.QuestionNumber === 1) && <><h3>Section {gr.SectionId} - {sectionNames[gr.SectionId - 1]}</h3></>}
                        Q{gr.QuestionNumber} <b>{gr.QuestionText}</b>
                        {['PositiveResponse', 'NeutralResponse', 'NegativeResponse'].map((r, index) =>
                            <div key={index} className={'response'}>
                                <span className={'context ' + r}>{gr[r + 'Context']}</span> {gr[r + 'Text']}
                            </div>
                        )}
                        <br></br>
                    </div>)
                })}
            </>}
        </>);

        addSection('responsesMaturity', 'Appendix B: Your Responses', <>
            {props.results && <>
                <div className="a_paragraph">Note, there is no right or wrong answer to these questions.</div>
                {a.comments&&<div className="a_paragraph">
                    <b>Comments from Aephoria</b>
                    <div className='response textResponse'>
                        <i>{a.comments}</i>
                    </div>
                </div>}
                {props.results.gresponses.filter((gr, index, self) => gr.SectionId === 4 && self.findIndex(t => t.QuestionNumber === gr.QuestionNumber) === index).map((gr, index) => {
                    return (<div className="a_paragraph" key={gr.QuestionNumber}>
                        Q{gr.QuestionNumber} <b>{gr.QuestionText}</b>
                        <div className='response textResponse'>
                            {gr.RawTextResponse}
                        </div>
                    </div>)
                })}
            </>}
        </>);
        
        props.results.postsurvey && addSection('postsurvey', 'Post Survey Responses', <>
            {props.results && <>
                {postSurveyQuestions.map((q, index) => {
                    return (<div key={index}>
                        Q{index + 1} <b>{q.question}</b><br></br>
                        {props.results.postsurvey[0] ? (props.results.postsurvey[0][q.field] ?? 'n/a') : 'n/a'}
                        <br></br>
                        <br></br>
                    </div>)
                })}
            </>}
        </>);

        tabs.sort((a, b) => sections.indexOf(a.id) - sections.indexOf(b.id));

        props.onTabsReady(tabs)
        // disable lint warning react-hooks/exhaustive-deps because of missing 'props' in useEffect dependency array:
        // eslint-disable-next-line
    }, [props.results, props.isNarrow]);

    return (headerContent)
};

export default StudioContent;

